import { FormControlLabel, Switch, Tooltip } from "@mui/material";

import {
  isPrivilegedModeToggleAvailable,
  useIsRealRoleElevated,
  usePrivilegedModeStore,
} from "@/utils/privilegedMode";

export function PrivilegedModeToggle() {
  const isRealElevated = useIsRealRoleElevated();
  const disabled = usePrivilegedModeStore((s) => s.disabled);
  const setDisabled = usePrivilegedModeStore((s) => s.setDisabled);

  if (!isPrivilegedModeToggleAvailable || !isRealElevated) return null;

  return (
    <Tooltip
      title={
        disabled
          ? "Privileged mode off — viewing as non-elevated user (dev only)"
          : "Privileged mode on (dev only)"
      }
    >
      <FormControlLabel
        data-testid="privileged-mode-toggle"
        sx={{ m: 0, mr: 2 }}
        control={
          <Switch
            size="small"
            checked={!disabled}
            onChange={(_, checked) => setDisabled(!checked)}
            inputProps={{ "aria-label": "Privileged mode" }}
          />
        }
        label="Privileged"
        slotProps={{
          typography: { sx: { fontSize: "0.75rem", ml: 2 } },
        }}
      />
    </Tooltip>
  );
}
